export enum PresentationEvents {

  FormModelDidUpdate = 'Presentation.FormModelDidUpdate',
}